export const download = (b64string: string, filename: string) => {
  const a = document.createElement("a");
  a.href = b64string;
  a.style.display = "none";
  if (filename?.length) {
    a.download = filename;
  }
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
